import ConfigVersionControlUi from "./VersionControlUi.jsx";
import { GET_SYSTEM_CONFIG, SET_SYSTEM_CONFIG } from "../../../../store/actions/ActionTypes.js";
import { apiCaller } from "../../../../services/AxiosInstance.js";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const ConfigVersionControl = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const response = await apiCaller({ url: 'configs' });
        dispatch({
            type: GET_SYSTEM_CONFIG,
            payload: response?.data?.data,
        });
        if (response) {
            localStorage.setItem('systemconfigs', JSON.stringify(response?.data?.data));
        }
        setLoading(false);
    }

    return !loading ? (
        <ConfigVersionControlUi />
    ) : null;
};

export default ConfigVersionControl;
